// React
import React from 'react';
import config from 'config';
import MaskedInput from 'react-input-mask'

class InputMask extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			format: {
				number: {'9': '[0-9]'},
				text: {'a': '[A-Za-z]'},
				all: {'*': '[A-Za-z0-9]'},
			}
		}
	}

	render() {

		let maskProps = Object.assign({}, this.props);
		let maskType = maskProps.maskType;
		delete maskProps.maskType;

		let maskedObject = <MaskedInput {...maskProps} />;

		if (maskType === "phoneNumber") {
			maskedObject = <MaskedInput
				formatChars={this.state.format.number}
				mask={config.application.countryConfig.masks.phoneNumber}
				{...maskProps}
			/>;
		}


		return (
			React.Children.only(maskedObject)
		);
	}
}

export default InputMask;


// WEBPACK FOOTER //
// ./src/components/shared/inputMask.component.jsx